var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#30367A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07356 12.5426V5.07825H5.90625V3.375H12.0938V5.07825H9.92644V12.5426H8.07356ZM7.57462 14.625C6.45581 14.625 5.9265 14.0872 5.9265 12.9499V5.5665H7.55438V12.8745C7.55438 13.0545 7.61344 13.1141 7.79006 13.1141H10.2308C10.4074 13.1141 10.467 13.0539 10.467 12.8745V5.5665H12.0938V12.9499C12.0938 14.0872 11.5639 14.625 10.4456 14.625H7.57462Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtk);
export default __webpack_public_path__ + "static/media/utk.a0c338db7a4fa315d52b753747c67ccc.svg";
export { ForwardRef as ReactComponent };